var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HandleButtonsList } from "./buttonController/HandleButtonsList";
import { HandleFieldsList } from "./fieldController/HandleFieldsList";
var FormFullHandler = /** @class */ (function () {
    function FormFullHandler(_a) {
        var _this = this;
        var onSubmit = _a.onSubmit, clearOnSubmit = _a.clearOnSubmit, submitOnClear = _a.submitOnClear, onChange = _a.onChange, disabled = _a.disabled;
        this.setNewField = function (name, fieldParams) {
            _this.formFieldsHandler.setNewField(name, fieldParams);
        };
        this.removeField = function (name) {
            _this.formFieldsHandler.removeField(name);
        };
        this.setNewButton = function (name, buttonParams) {
            _this.formButtonsHandler.setNewButton(name, buttonParams);
        };
        this.removeButton = function (name) {
            _this.formButtonsHandler.removeButton(name);
        };
        this.setCurrentValues = function (currentValues) {
            _this.formFieldsHandler.setCurrentValues(currentValues);
        };
        this.getDisabledForm = function () {
            return _this.disabled;
        };
        this.setFormDisabled = function (disabled) {
            _this.disabled = disabled;
            _this.formFieldsHandler.setAllDisabled(disabled);
            _this.formButtonsHandler.setButtonsDisabled(disabled);
        };
        this.setFieldRequired = function (name, required) {
            _this.formFieldsHandler.setFieldRequired(name, required);
        };
        this.setFieldDefaultValue = function (name, defaultValue) {
            _this.formFieldsHandler.setFieldDefaultValue(name, defaultValue);
        };
        this.setFieldLabel = function (name, label) {
            _this.formFieldsHandler.setFieldLabel(name, label);
        };
        this.setFieldMask = function (name, mask) {
            _this.formFieldsHandler.setFieldMask(name, mask);
        };
        this.setFieldMaskToSubmit = function (name, maskToSubmit) {
            _this.formFieldsHandler.setFieldMaskToSubmit(name, maskToSubmit);
        };
        this.setFieldValidation = function (name, validation) {
            _this.formFieldsHandler.setFieldValidation(name, validation);
        };
        this.setFieldAsyncValidation = function (name, asyncValidation) {
            _this.formFieldsHandler.setFieldAsyncValidation(name, asyncValidation);
        };
        this.getFieldRef = function (name) {
            return _this.formFieldsHandler.getFieldRef(name);
        };
        this.setValue = function (name, value) {
            _this.formFieldsHandler.setValue(name, value);
        };
        this.setFormValue = function (name, value) {
            _this.formFieldsHandler.setFormValue(name, value);
            if (_this.onChange) {
                _this.onChange();
            }
        };
        this.clearValue = function (name, setDefault) {
            if (setDefault === void 0) { setDefault = true; }
            _this.formFieldsHandler.clearValue(name, setDefault);
        };
        this.getValue = function (name, withMaskToSubmit) {
            return _this.formFieldsHandler.getValue(name, withMaskToSubmit, _this);
        };
        this.getActualValue = function (name) {
            return _this.formFieldsHandler.getActualValue(name);
        };
        this.getValues = function () {
            return _this.formFieldsHandler.getValues(_this);
        };
        this.setFieldFocus = function (name) {
            _this.formFieldsHandler.setFieldFocus(name);
        };
        this.getValidValues = function (valuesWithMaskToSubmit) {
            return _this.formFieldsHandler.getValidValues(valuesWithMaskToSubmit, _this);
        };
        this.testErrorsAndReturnData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.formFieldsHandler.testErrorsAndReturnData(this)];
            });
        }); };
        this.testFieldError = function (name, shouldUpdateInput) {
            if (shouldUpdateInput === void 0) { shouldUpdateInput = true; }
            return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.formFieldsHandler.testFieldError(name, shouldUpdateInput, this)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        this.clearFields = function (setDefault) {
            if (setDefault === void 0) { setDefault = true; }
            _this.formFieldsHandler.clearFields(setDefault);
            if (_this.submitOnClear) {
                _this.submit();
            }
        };
        this.clearSpecificFields = function (names, setDefault) {
            if (setDefault === void 0) { setDefault = true; }
            _this.formFieldsHandler.clearSpecificFields(names, setDefault);
        };
        this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, hasError, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.onSubmit) return [3 /*break*/, 2];
                        this.formButtonsHandler.setButtonsStatus(true);
                        return [4 /*yield*/, this.testErrorsAndReturnData()];
                    case 1:
                        _a = _b.sent(), hasError = _a.hasError, data = _a.data;
                        this.formButtonsHandler.setButtonsStatus(false);
                        if (!hasError) {
                            this.onSubmit(data);
                            if (this.clearOnSubmit) {
                                this.formFieldsHandler.clearFields(true);
                            }
                        }
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.onSubmit = onSubmit;
        this.onChange = onChange;
        this.clearOnSubmit = clearOnSubmit !== null && clearOnSubmit !== void 0 ? clearOnSubmit : false;
        this.submitOnClear = submitOnClear !== null && submitOnClear !== void 0 ? submitOnClear : false;
        this.disabled = disabled !== null && disabled !== void 0 ? disabled : false;
        this.formButtonsHandler = new HandleButtonsList();
        this.formFieldsHandler = new HandleFieldsList();
    }
    FormFullHandler.handleError = {
        fieldNotFound: function (name) {
            if (!name)
                console.error("A field was not informed, received: " + name);
            else
                console.error("The field \"" + name + "\" does not exist.");
        },
    };
    return FormFullHandler;
}());
export default FormFullHandler;
